<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'orgs')" class="tab__footer page__active_bar">
      <el-button
        id="addOrg"
        class="page__active_button"
        type="primary"
        icon="el-icon-plus"
        @click="$router.push({ name: 'org:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
    <div class="page_container">
      <search :query.sync="query" @search="search" />
      <orgs-table @orgDeleted="changePage(page)" />
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import list from "@/core/mixins/list";
import OrgsTable from "@/components/Orgs/features/OrgsTable";

export default {
  name: "OrgsList",
  components: {
    OrgsTable,
    Search,
  },
  mixins: [list],
  data() {
    return { query: "", activeName: "list" };
  },
  computed: {
    ...mapState("orgs", ["total", "count"]),
    ...mapGetters("orgs", ["getQuery"]),
  },
  methods: {
    ...mapActions("orgs", {
      getList: "GET_LIST_ORGS",
    }),
    ...mapMutations("orgs", {
      setQuery: "SET_QUERY",
    }),
  },
};
</script>

<style>
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.el-table th > .cell {
  word-break: break-word;
}
.link {
  line-height: 1;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}
</style>
